import { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";

const ImageBox = ({ id, src, alt, isSelected, onClick }) => (
  <Box
    sx={{
      position: "relative",
      width: "100%",
      height: "200px", // Height of the box larger than the image size
      border: 2,
      padding: "2px",
      borderRadius: 2,
      cursor: "pointer",
      transition: "all 0.3s",
      borderColor: isSelected ? "primary.main" : "grey.300",
      boxShadow: isSelected ? "0 0 0 7px #1976d2" : "none", // Ring effect for selected
      "&:hover": {
        borderColor: "primary.main",
      },
      "&:focus, &:focus-visible": {
        outline: "3px solid #000",
        outlineOffset: 2,
        // boxShadow: "0 0 0 7px #000",
      },
    }}
    onClick={() => onClick(id)}
    onKeyDown={(e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        onClick(id);
      }
    }}
    role="button"
    aria-pressed={isSelected}
    tabIndex={0}
  >
    <img
      src={src}
      alt={alt || `Background option ${id + 1}`}
      style={{
        display: "block",
        objectFit: "cover", // Ensures the image covers the area of the box
        width: "100%",
        height: "100%", // Make the image fill the box
        borderRadius: "8px", // Rounded corners for the image
      }}
    />
  </Box>
);

export default function GridSelectorModal({ images, alts = [], onClick, initialAltText = "" }) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [altText, setAltText] = useState(initialAltText);

  useEffect(() => {
    setAltText(initialAltText);
  }, [initialAltText, isOpen]);

  const handleImageClick = (id) => {
    setSelectedImage(id);
    if (alts && alts[id]) {
      setAltText(alts[id]);
    } else if (typeof images[id] === "object" && images[id]?.accessibilityLabel) {
      setAltText(images[id].accessibilityLabel);
    }
  };

  const handleOkClick = () => {
    if (selectedImage !== null) {
      onClick(selectedImage, altText);
    }
    setIsOpen(false);
  };

  return (
    <>
      <Button variant="contained" onClick={() => setIsOpen(true)}>
        Background Selector
      </Button>
      <Dialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
        aria-labelledby="image-selector-dialog-title"
        maxWidth="md"
        fullWidth
      >
        <DialogTitle id="image-selector-dialog-title">Background Selector</DialogTitle>
        <DialogContent>
          <Grid sx={{
            marginTop: "10px",
          }} container spacing={2} >
            {images.map((item, i) => {
              const src = typeof item === "object" ? (item.url || item.src) : item;
              const imgAlt = (alts && alts[i])
                ? alts[i]
                : (typeof item === "object" && (item.accessibilityLabel || item.alt))
                  ? (item.accessibilityLabel || item.alt)
                  : `Background option ${i + 1}`;
              return (
                <Grid item xs={4} key={i}>
                  <ImageBox
                    id={i}
                    src={src}
                    alt={imgAlt}
                    isSelected={selectedImage === i}
                    onClick={handleImageClick}
                  />
                </Grid>
              );
            })}
          </Grid>
          {/* <TextField
            label="Alt text (accessibilityLabel)"
            fullWidth
            margin="normal"
            value={altText}
            onChange={(e) => setAltText(e.target.value)}
            helperText="In case any future images contain informative content"
            InputLabelProps={{ shrink: true }}
            sx={{ mt: 3, backgroundColor: "white" }}
          /> */}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsOpen(false)} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleOkClick} disabled={selectedImage === null}>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
